import React from "react";

export const SetLessonDataContext = React.createContext<React.Dispatch<
  React.SetStateAction<{
    teacherId: number | string;
    subjectId: number | string;
    lessonId: string | number;
    lessonName: string;
  }>
> | null>(null);
